import React from 'react';
export default {
  'cart': {
    'change-currency': 'Verander munteenheid',
    'and-then': 'En dan',
    'plus-tax': ' + btw',
    'for': 'Voor',
    'edit': {
      'label': 'Bewerken',
      'submit': 'Toepassen'
    },
    'empty': 'Je hebt nog niets aan je bestelling toegevoegd.',
    'free': 'gratis',
    'promo-code': {
      'add': 'Voeg cadeaukaart of promocode toe',
      'error': {
        'invalid-for-subscription': 'De kortingscode is niet geldig voor deze bestelling.'
      },
      'label': 'Cadeaukaart of promocode',
      'submit': 'Toepassen'
    },
    'subtotal-line': {
      'tax-label': 'Geschatte btw',
      'subtotal': 'Subtotaal',
      'tax': 'belasting',
      'gift-card': 'Cadeaukaart'
    },
    'starting-price': 'Beginprijs',
    'title': 'Besteloverzicht',
    'setup-fee': 'vergoeding voor opzetten',
    'free-trial': 'Gratis proefperiode',
    'total-line': {
      'label': 'Totaal'
    },
    'order-total-line': {
      'label': 'Volledige Bestelling'
    }
  },
  'address': {
    'country': 'Land',
    'address2': 'Appartement, suite enzovoort',
    'tax-identifier': 'Belasting-ID',
    'tax-identifier-type': 'Type belastingidentificatie',
    'first-name': 'Voornaam',
    'last-name': 'Achternaam',
    'company-name': 'Bedrijfsnaam',
    'address1': 'Straatadres',
    'city': 'Stad/Woonplaats',
    'state': 'Provincie',
    'postal-code': 'postcode',
    'phone-number': 'Telefoonnummer',
    'vat-number': 'BTW-nummer/Belasting-ID'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Kaartgegevens',
      'expiry': 'MM/JJ',
      'name': 'Credit Card',
      'number': 'Credit Card Nummer',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'Bankrekening',
      'routing-number': 'Routing Number',
      'account-number': 'Rekening Nummer',
      'account-number-confirmation': 'Bevestig Account Number',
      'account-type': {
        'label': 'Account Type',
        'checking': 'Account Controleren',
        'savings': 'Spaarrekening'
      },
      'name-on-account': 'Naam op Account'
    },
    'amazon': {
      'name': 'Amazon'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Sort Code'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'BSB Code'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Factuuradres',
  'billing-address-same-as-shipping': 'Hetzelfde als leveringsadres',
  'submit': 'Nu betalen',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} geselecteerd</>,
  'express-checkout': 'Snel afrekenen',
  'change-payment-method': 'Betaalmethode wijzigen',
  'day': 'dag',
  'days': 'dagen',
  'week': 'week',
  'weeks': 'weken',
  'month': 'maand',
  'months': 'maanden',
  'year': 'jaar',
  'years': 'jaren',
  'confirmation': {
    'title': 'Bedankt voor uw bestelling',
    'order-num': ({ number }: { number: number }) => <>Bestel #{number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Voltooid op {date}</>,
    'email-notice': 'U ontvangt per e-mail een bevestiging van uw bestelling.',
    'payment': 'Betaling',
    'return-to': ({ name }: { name: string }) => <>Terugzenden aan {name}</>,
    'credit-applied': 'Krediet toegepast'
  },
  'back': 'Terug',
  'contact-info': 'Contact Informatie',
  'email-address': 'email',
  'payment-info': 'Informatie Facturering',
  'shipping-address': 'Afleveradres',
  'legal': {
    'accept': 'Ik accepteer de',
    'privacy-policy': 'Privacy Beleid',
    'terms-of-service': 'Voorwaarden van Dienstverlening'
  },
  'recurring': {
    'consent': `Ik ga ermee akkoord bovenstaande kosten, weergegeven met een factureringsfrequentie, periodiek te betalen,
                tenzij het abonnement voor het einde van de huidige factureringsperiode wordt opgezegd.`,
    'cancel': 'Om uw abonnement op te zeggen, gaat u naar uw pagina voor Accountbeheer.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'dag' : 'dagen',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'week' : 'weken',
    'months': ({ count }: { count: number }) => count === 1 ? 'maand' : 'maanden',
    'years': ({ count }: { count: number }) => count === 1 ? 'jaar' : 'jaren'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>U wordt {amount}/eenheid in rekening gebracht voor {addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>U wordt {amount} in rekening gebracht voor {units} {unitsLabel} van {addOnName}</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>Vanaf {startDate} wordt u {amount}/{intervalLengthLabel}{taxable ? ' + belasting' : ''} gefactureerd</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>Vanaf {startDate} wordt u {amount}/{intervalLengthLabel}{taxable ? ' + belasting' : ''} gefactureerd, samen met een eenmalige vergoeding van {setupFee}</>,
      'cancellation.reminder': 'U ontvangt {days} dagen voordat de facturering begint een e-mailherinnering.',
      'trial.start': ({ trialLength, trialInterval }: { trialLength: string; trialInterval: string }) => <>Uw gratis proefperiode van {trialLength} {trialInterval} begint vandaag.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>Om te voorkomen dat u wordt gefactureerd, moet u vóór {trialEndsAt} annuleren.</>,
      'email.reminder': ({ days }: { days: number }) => <>U ontvangt {days} dagen voordat de facturering begint een e-mailherinnering</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Uw abonnement eindigt op {billingEndsAt} en wordt niet automatisch verlengd.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>Na {afterChargeTime} wordt u {newChargeAmount} + belasting in rekening gebracht</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Uw abonnement wordt automatisch verlengd elke {totalCyclesLengthLabel} en wordt voortgezet totdat u annuleert.</>,
      'title': 'Abonnementdetails',
    },
    'agreement.button': 'Akkoord & Doorgaan',
    'agreement.text': 'Door op "Akkoord & Doorgaan" te klikken, bevestigt u dat u deze abonnementsvoorwaarden begrijpt en accepteert. Er worden geen kosten berekend totdat u de afrekening voltooit.',
    'changeOrCancel': 'Om uw abonnement te wijzigen of op te zeggen ',
    'access-account': 'ga naar uw account',
    'contact-support': 'neem contact op met ondersteuning',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' en ',
      'lastWordConnector': ' en '
    }
  },
  'powered-by': 'Facturering abonnement mogelijk gemaakt door {recurly}',
  'errors': {},
  'subscribe': 'Abonneer'
};
